<script>
import Popup from './popup.vue';
import Loading from '../loading.vue';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    name: "order",
    data() {
        return {
            list: [],
            isShowLogistics: false,
            isLoadingLogistics: false,
            logisticsInfo: [],
        };
    },
    computed: {
        detailPath() {
            return (type) => {
                switch (type) {
                    case 1:
                    case '1':
                        return '/shop/detail?id=';
                        break;
                    case 2:
                    case '2':
                        return '/gallery/works/detail?id=';
                        break;
                    default:
                        return '/shop/detail?id=';
                        break;
                }
            }
        },
    },
    components: {
        Popup,
        Loading
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            immediate: true,
            handler(val) {
                if (!Array.isArray(val)) {
                    this.list = [];
                    return;
                }
                this.list = val.map((item) => ({
                    ...item,
                    isShowLogistics: false,
                }));
            },
        },
    },
    methods: {
        showLogistics(code) {
            this.isShowLogistics = true;
            this.isLoadingLogistics = true;
            this.logisticsInfo = [];
            this.$store.dispatch('getShopOrderLogistics', {
                order_code: code,
            }).then((result) => {
                this.isLoadingLogistics = false;
                if (result.code == 100) { 
                    this.logisticsInfo = result.data;
                }else{
                    this.$showToast({ text: result.msg || '获取物流信息失败' });
                }
            }).catch((err) => {
                this.isLoadingLogistics = false;
                this.$showToast({ text: '获取物流信息失败' });
            });
        },
        // 加入购物车
        addToCart(id) {
            this.$showLoading();
            this.$store.dispatch('addCart', {
                id: id,
                type: 1,
                count: 1,
            }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '添加成功' });
                } else if (result.code == 90) {
                    this.$showToast({ text: '登录凭证已失效' });
                    this.toLogin();
                } else if (result.code == 101) { 
                    this.$showToast({ text: '添加失败，库存不足' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '商品已经在购物车了' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: '添加失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
    },
};
</script>

<template>
    <div class="table order">
        <div class="item thead only_pc">
            <div class="tr">
                <div class="td">订单信息</div>
                <div class="td">商品价格</div>
                <div class="td">实付款</div>
                <div class="td">订单操作</div>
            </div>
        </div>
        <div class="item" v-for="(item, index) in list" :key="index">
            <div class="top flex align_center">
                <p class="time">{{item.created_at}}</p>
                <p class="code">订单号：{{item.order_code}}</p>
                <!-- 支付状态 -->
                <p v-if="item.order_status == 0">未支付</p>
                <p v-if="item.order_status == 1">待发货</p>
                <p v-if="item.order_status == 5">已发货</p>
                <p v-if="item.order_status == 2">已收货</p>
                <p v-if="item.order_status == 3">退货退款</p>
                <p v-if="item.order_status == 4">已取消</p>
            </div>
            <!-- pc -->
            <div class="tr only_pc">
                <div class="td">
                    <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                        <router-link class="layout_bg cover" :style="`background-image: url(${_item.item_image});`" :to="`${detailPath(_item.type)}${_item.item_id}`"></router-link>
                        <div class="wrapper">
                            <p class="name">
                                <router-link :to="`${detailPath(_item.type)}${_item.item_id}`">{{_item.item_name}}</router-link>
                            </p>
                            <div class="info_btn_group">
                                <div class="btn layout_flex_center" @click="addToCart(_item.item_id)">加入购物车</div>
                                <router-link class="btn layout_flex_center" v-if="item.order_status != 4" :to="`/mine/order/afterSale?code=${item.order_code}&id=${_item.id}`">申请售后</router-link>
                            </div>
                        </div>
                        <p class="count layout_flex_center">x{{_item.qty}}</p>
                    </div>
                </div>
                <div class="td flex flex_column">
                    <p class="price layout_flex_center" v-for="(_item, _index) in item.item" :key="_index">RMB {{_item.price}}</p>
                </div>
                <div class="td layout_flex_center">
                    <p class="price2">实际付款：RMB {{item.amount}}<br/>含运费：RMB {{ item.freight }}</p>
                </div>
                <div class="td layout_flex_center">
                    <!-- 未支付 -->
                    <div class="btn_group" v-if="item.order_status == 0">
                        <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">去支付</router-link>
                    </div>
                    <!-- 已支付 待发货 -->
                    <div class="btn_group" v-if="item.order_status == 1">
                        <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                        <router-link class="btn layout_flex_center" v-if="item.item.length == 1" :to="`${detailPath(item.item[0].type)}${item.item[0].item_id}`">再次购买</router-link>
                    </div>
                    <!-- 已发货 -->
                    <div class="btn_group" v-if="item.order_status == 5">
                        <div class="btn layout_flex_center" @click="showLogistics(item.order_code)">查看物流</div>
                    </div>
                </div>
            </div>
            <!-- 移动端 -->
            <div class="only_mobile">
                <div class="info" v-for="(_item, _index) in item.item" :key="_index">
                    <router-link class="layout_bg cover" :style="`background-image: url(${_item.item_image});`" :to="`${detailPath(_item.type)}${_item.item_id}`"></router-link>
                    <div class="wrapper">
                        <p class="name"><router-link :to="`${detailPath(_item.type)}${_item.item_id}`">{{_item.item_name}}</router-link></p>
                        <p class="count">x{{_item.qty}}</p>
                        <p class="price">实际付款 RMB {{_item.price}}</p>
                        <div class="btn_group">
                            <div class="btn layout_flex_center" @click="addToCart(_item.item_id)">加入购物车</div>
                            <router-link class="btn layout_flex_center" v-if="item.order_status != 4" :to="`/mine/order/afterSale?code=${item.order_code}&id=${_item.id}`">申请售后</router-link>
                        </div>
                    </div>
                </div>
                <!-- 未支付 -->
                <div class="btn_group" v-if="item.order_status == 0">
                    <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">去支付</router-link>
                </div>
                <!-- 已支付 待发货 -->
                <div class="btn_group" v-if="item.order_status == 1">
                    <router-link class="btn layout_flex_center" :to="`/shopping/pay?code=${item.order_code}`">订单详情</router-link>
                    <router-link class="btn layout_flex_center" v-if="item.item.length == 1" :to="`${detailPath(item.item[0].type)}${item.item[0].item_id}`">再次购买</router-link>
                </div>
                <!-- 已发货 -->
                <div class="btn_group" v-if="item.order_status == 5">
                    <div class="btn layout_flex_center" @click="showLogistics(item.order_code)">查看物流</div>
                </div>
            </div>
        </div>
        <Popup :show="isShowLogistics" title="物流信息" :is-show-close="true" @close="isShowLogistics = false">
            <div class="loading_wrap" v-if="isLoadingLogistics">
                <Loading/>
            </div>
            <div class="no_more" v-else-if="logisticsInfo.length == 0">
                <p>暂无物流信息</p>
            </div>
            <div v-else>
                <div class="logistics" v-for="(logistic, index) in logisticsInfo" :key="index">
                    <p class="exp_name">
                        {{ logistic.express.result.expName }}（{{ logistic.express.result.number }}）
                    </p>
                    <div class="logistics_list">
                        <div class="logistics_info" v-for="(info, _index) in logistic.express.result.list" :key="_index">
                            <p class="time">{{ info.time }}</p>
                            <p class="status">{{ info.status }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    </div>
</template>

<style scoped lang="scss">
@import './table.scss';
.logistics{
    .exp_name{
        font-size: .24rem;
        font-weight: bold;
        margin-bottom: .2rem;
    }
    .logistics_list{
        max-height: 4rem;
        overflow: hidden;
        overflow-y: auto;
        @media screen and (max-width: 750px) {
            max-height: 6rem;
        }
        .logistics_info{
            padding: .1rem 0;
            font-size: .22rem;
            border-bottom: 1px solid #666;
            &:last-child{
                border-bottom: none;
            }
            .time{
                margin-bottom: .1rem;
            }
        }
    }
}
.order{
    .price{
        flex: 1;
        margin-top: .2rem;
        &:first-child{
            margin-top: 0;
        }
    }
    .tr{
        .td{
            &:nth-of-type(1){
                width: 50%;
            }
            &:nth-of-type(2){
                width: 15%;
            }
            &:nth-of-type(3){
                width: 20%;
            }
            &:nth-of-type(4){
                width: 15%;
            }
        }
    }
}
</style>